(function () {
  'use strict';

  if (typeof window.momentOfSilenceSettings === 'undefined' || !window.momentOfSilenceSettings.enabled) {
    return;
  }

  var settings = window.momentOfSilenceSettings;
  var modalElement = null;

  var originalBodyOverflow = ''; // Store original body overflow style
  var originalBodyPosition = ''; // Store original body position
  var timerInterval = null; // Timer interval

  /** Scroll lock state **/
  var scrollLockActive = false;
  var scrollLockY = 0;
  var originalBodyLeft = '';
  var originalBodyRight = '';
  var originalBodyWidth = '';
  var originalBodyTop = '';
  var preventScrollHandler = function (e) {
    if (scrollLockActive) {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
      }
      return false;
    }
  };

  function decodeHtmlEntities(text) {
    var txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
  }

  function init() {
    const now = new Date(); 

    const targetTime = settings.target_time;
    const targetHours = parseInt(targetTime.split(":")[0]);
    const targetMins = parseInt(targetTime.split(":")[1]);

    const targetDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      targetHours, 
      targetMins, 
      0, 0
    );

    const endTime = settings.end_time;
    const endHours = parseInt(endTime.split(":")[0]);
    const endMins = parseInt(endTime.split(":")[1]);

    const endDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      endHours, 
      endMins, 
      0, 0
    );

    var targetTimestamp = targetDate.getTime();
    var endTimestamp = endDate.getTime();

    if (!targetTimestamp || !endTimestamp) {
      console.error('Moment of Silence: Invalid timestamps from server');
      return;
    }

    if (now >= targetTimestamp && now < endTimestamp) {
      showModal(now < targetTimestamp + 2000, endTimestamp);
    } else if (now < targetTimestamp) {
      var delay = targetTimestamp - now;
      setTimeout(function () {
        showModal(true, endTimestamp); // Show with announcement
      }, delay);
    }
  }

  function showModal(withAnnouncement, endTimestamp) {
    try {
      // Save originals
      originalBodyOverflow = document.body.style.overflow || '';
      originalBodyPosition = document.body.style.position || '';
      originalBodyLeft = document.body.style.left || '';
      originalBodyRight = document.body.style.right || '';
      originalBodyWidth = document.body.style.width || '';
      originalBodyTop = document.body.style.top || '';

      // Lock scroll by fixing body
      scrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-scrollLockY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      scrollLockActive = true;

      // Prevent default scroll/touch events
      window.addEventListener('touchmove', preventScrollHandler, { passive: false, capture: true });
      window.addEventListener('wheel', preventScrollHandler, { passive: false, capture: true });
      window.addEventListener('scroll', preventScrollHandler, { passive: false, capture: true });
    } catch (e) {
      console.warn('Moment of Silence: Failed to lock scroll', e);
    }

    // Create modal HTML
    modalElement = document.createElement('div');
    modalElement.id = 'moment-of-silence-modal';
    modalElement.style.cssText = 'position:fixed;inset:0;width:100%;height:100dvh;min-height:100vh;background:rgba(0,0,0,0.92);z-index:2147483647;display:flex;align-items:center;justify-content:center;font-family:Arial,sans-serif;overflow:hidden;touch-action:none;';

    var modalContent = document.createElement('div');
    modalContent.style.cssText = 'background:#fff;padding:clamp(25px,5vw,50px) clamp(20px,4vw,40px);border-radius:12px;max-width:min(650px,90vw);width:90%;text-align:center;box-shadow:0 10px 50px rgba(0,0,0,0.5);animation:fadeIn 0.5s ease-out;margin:15px;box-sizing:border-box;position:relative;z-index:2147483647;';

    if (settings.title) {
      var title = document.createElement('h2');
      title.textContent = settings.title;
      title.style.cssText = 'margin:0 0 20px;font-size:clamp(24px,5vw,32px);color:#222;font-weight:600;line-height:1.3;';
      modalContent.appendChild(title);
    }

    // Timer display
    var timer = document.createElement('div');
    timer.id = 'moment-of-silence-timer';
    timer.textContent = '01:00';
    timer.style.cssText = 'font-size:clamp(42px,8vw,56px);font-weight:700;margin:15px 0 25px;font-family:"Courier New",monospace;color:#444;letter-spacing:0.05em;';
    modalContent.appendChild(timer);


    if (settings.message) {
      var message = document.createElement('div');
      // Decode HTML entities if they were escaped by json_encode
      message.innerHTML = decodeHtmlEntities(settings.message);
      message.style.cssText = 'margin:0;font-size:clamp(14px,3.5vw,18px);color:#555;line-height:1.6;text-align:left;';
      // Add basic styles for HTML elements
      var messageStyle = document.createElement('style');
      messageStyle.textContent = '#moment-of-silence-modal p { margin: 8px 0; text-align: center; } #moment-of-silence-modal ul, #moment-of-silence-modal ol { margin: 8px 0; padding-left: 20px; } #moment-of-silence-modal strong { font-weight: bold; } #moment-of-silence-modal a { color: #337ab7; text-decoration: underline; } @media (max-width: 480px) { #moment-of-silence-modal ul, #moment-of-silence-modal ol { padding-left: 15px; } }';
      document.head.appendChild(messageStyle);
      modalContent.appendChild(message);
    }

    modalElement.appendChild(modalContent);
    document.body.appendChild(modalElement);

    // Add animation
    var style = document.createElement('style');
    style.textContent = '@keyframes fadeIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }';
    document.head.appendChild(style);

    // modalElement.onclick = function (e) {
    //   // Prevent modal from closing
    //   e.preventDefault();
    //   e.stopPropagation();
    //   return false;
    // };

    // Prevent ESC key
    document.addEventListener('keydown', preventClose);

    // Store end timestamp globally
    window.momentOfSilenceEndTime = endTimestamp;

    // Start timer updates
    startTimer(endTimestamp);

    // Auto-close modal after time expires
    var closeTime = endTimestamp - Date.now();
    if (closeTime > 0) {
      setTimeout(function () {
        closeModal();
      }, closeTime);
    }
  }

  function startTimer(endTimestamp) {
    function updateTimer() {
      var now = Date.now();
      var remainingMs = Math.max(0, endTimestamp - now);
      var remaining = Math.floor(remainingMs / 1000); // Floor для точного відображення повних секунд

      var minutes = Math.floor(remaining / 60);
      var seconds = remaining % 60;

      var timerElement = document.getElementById('moment-of-silence-timer');
      if (timerElement) {
        timerElement.textContent =
          (minutes < 10 ? '0' : '') + minutes + ':' +
          (seconds < 10 ? '0' : '') + seconds;
      }

      // Stop timer when time is up
      if (remainingMs <= 0 && timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
    }

    // Update immediately
    updateTimer();

    timerInterval = setInterval(updateTimer, 100);
  }

  function preventClose(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  function closeModal() {
    // Stop timer
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }

    if (modalElement && modalElement.parentNode) {
      modalElement.parentNode.removeChild(modalElement);
      modalElement = null;
    }

    // Restore original body styles (enable scrolling)
    try {
      // Remove prevention listeners
      window.removeEventListener('touchmove', preventScrollHandler, { capture: true });
      window.removeEventListener('wheel', preventScrollHandler, { capture: true });
      window.removeEventListener('scroll', preventScrollHandler, { capture: true });
      scrollLockActive = false;

      // Restore body styles
      document.body.style.overflow = originalBodyOverflow || '';
      document.body.style.position = originalBodyPosition || '';
      document.body.style.left = originalBodyLeft || '';
      document.body.style.right = originalBodyRight || '';
      document.body.style.width = originalBodyWidth || '';
      document.body.style.top = originalBodyTop || '';
      // Restore scroll position
      if (typeof scrollLockY === 'number' && !isNaN(scrollLockY)) {
        window.scrollTo(0, scrollLockY);
      }
    } catch (e) {
      console.warn('Moment of Silence: Failed to unlock scroll', e);
    }

    document.removeEventListener('keydown', preventClose);
  }

  init();
})();

